import { render, staticRenderFns } from "./AbstractContent.vue?vue&type=template&id=bf7d46b6&scoped=true&"
import script from "./AbstractContent.vue?vue&type=script&lang=js&"
export * from "./AbstractContent.vue?vue&type=script&lang=js&"
import style0 from "./AbstractContent.vue?vue&type=style&index=0&id=bf7d46b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7d46b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
